import React, { FC, useEffect } from 'react';
import { Button, Form, InputNumber, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { rules } from 'common/helpers/form.helper';
import { EFormFieldMessage } from 'common/const/form.enum';
import { IFormValue } from 'common/models';

interface IComponentProps {
  open: boolean;
  defaultValue?: number;
  loading: boolean;
  onClose: () => void;
  onApply: (value: number, onSuccess: () => void) => void;
}

export const RequestSupplyChangePriceModal: FC<IComponentProps> = ({ open, defaultValue, loading, onClose, onApply }) => {
  const [form] = useForm();

  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
    form.resetFields();
  };

  const onSubmit = ({ price }: IFormValue) => {
    onApply(price, handleClose);
  };

  useEffect(() => {
    if (open && defaultValue) {
      form.setFieldsValue({
        price: defaultValue,
      });
    }
  }, [open, defaultValue]);

  return (
    <Modal
      rootClassName="redesign modal"
      width={420}
      centered
      open={open}
      onCancel={handleClose}
      destroyOnClose
      closeIcon={false}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} loading={loading}>
          Отмена
        </Button>,
        <Button key="apply" className="button-sm primary" onClick={form.submit} loading={loading}>
          Применить
        </Button>,
      ]}
    >
      <div className="text-h4 mb-6">Корректировать стоимость</div>

      <div className="text-tag color-dark-grey mb-6">
        Если изменилась цена товара, вы можете обновить её для этого заказа. Информация об изменении будет отображена в сведениях
        о позиции.
      </div>

      <Form form={form} requiredMark={false} layout="vertical" onFinish={onSubmit}>
        <Form.Item label="Цена за ед. товара" name="price" rules={[rules.required(true, EFormFieldMessage.RequiredField)]}>
          <InputNumber placeholder="Введите цену за ед. товара" controls={false} suffix="₽" precision={2} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
